import { CustomDropdown } from '@components/onboarding/form/steps/styles';
import {
  US_COAT_LENGTH_OPTIONS,
  US_COAT_LENGTH_VALUE_TO_OPTION,
} from '@lib/utils/constants/measurementConstants';

type CoatLengthDropdownProps = {
  handleInputChange: (name: string, value: string) => void;
  onChange?: (value: string) => void;
  value?: string;
  isMobile?: boolean;
};
export const CoatLengthDropdown = ({
  handleInputChange,
  onChange,
  value,
  isMobile = false,
  ...props // Props injected by `Form.Item`
}: CoatLengthDropdownProps) => {
  const normalizedValue = value
    ? {
        key: value,
        value,
        label: US_COAT_LENGTH_VALUE_TO_OPTION[value].shortLabel,
      }
    : null;

  return (
    <CustomDropdown
      {...props}
      isMobile={isMobile}
      value={normalizedValue}
      labelInValue
      placeholder='Select'
      onChange={(selectedOption: SelectValue | null) => {
        if (!selectedOption?.value) return;
        handleInputChange('us_coat_length', selectedOption.value);
        if (onChange) {
          onChange(selectedOption.value);
        }
      }}
      options={selectOptions}
    />
  );
};

const selectOptions = US_COAT_LENGTH_OPTIONS.map(({ value, longLabel }) => ({
  label: longLabel,
  value,
  key: value,
}));

type SelectValue = {
  key: string;
  label: string;
  value: UsCoatLengthEnum;
};
